import {ChangeDetectionStrategy, Component, Input} from '@angular/core'

@Component({
  selector: 'bgo-option-count',
  templateUrl: './option-count.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptionCountComponent {
  @Input() optionCount?: number
  @Input() itemCount?: number
}
